import { TrackingApi } from '../../../api/Tracking'
import Tracking from '../../../components/Main/Tracking/Tracking'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function TrackingCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => TrackingApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('Tracking')

  return (
    <Tracking
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default TrackingCont
